import React, { FC } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { routes } from 'utils/routing';

import { LAST_QUEUE_EXIT_TIMESTAMP } from './constants';
import { useTrackOrder } from './hooks/use-track-order';
import { OrderTrackingBanner } from './order-tracking-banner';

export const OrderTrackingBannerContainer: FC = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const lastQueueExitTimestamp = new Date(searchParams.get(LAST_QUEUE_EXIT_TIMESTAMP) || '');

  const { orderInProgress, message } = useTrackOrder({ lastQueueExitTimestamp });

  if (!orderInProgress) {
    return null;
  }

  return (
    <>
      <OrderTrackingBanner
        message={message}
        onClick={() => navigate(`${routes.orderConfirmation}/${orderInProgress.rbiOrderId}`)}
      />
    </>
  );
};
